.menu-frame {
  --chevron-padding-right: 4px;
  --chevron-size: 24px;

  position: relative;
}

.dropdown-button {
  cursor: pointer;
  user-select: none;

  &:focus {
    outline: none;
  }
}

.arrow-base {
  position: absolute;
  pointer-events: none;
  user-select: none;
}

.dropdown-menu {
  user-select: none;
  box-shadow: 0 3px 5px 0 rgba(98, 114, 129, 0.2);

  &:not(.in-document-flow) {
    position: absolute;
    z-index: var(--popup-menu-z-index);
  }
}

a.dropdown-choice {
  display: block;
  text-decoration: none;
}

.dropdown-choice {
  cursor: pointer;
  user-select: none;

  &:hover,
  &:focus {
    outline: none;
    background-color: rgba(212, 224, 251, 0.24);
  }
}
